// extracted by mini-css-extract-plugin
export var orderSummary = "_ro-0";
export var showMoreLessButton = "_ro-1";